import React from 'react';
import propTypes from 'prop-types';
import { Spinner, Col } from 'react-bootstrap';

const Loader = (props) => {
  if(props.type === 'inline') return <span className="loader-inline"></span>;
  return (
    <Col className={`${props.container ? 'loader-container-full' : 'loader-container-parent'}`}>
      {props.type === 'spinner' && <Spinner animation="border" variant={props.variant ? props.variant : 'primary'} size={props.size} className={props.animationClasses ? props.animationClasses : ''} />}
      {props.type === 'pulseCircle' && <Spinner animation="grow" variant={props.variant ? props.variant : 'primary'} size={props.size} className={props.animationClasses ? props.animationClasses : ''} />}
    </Col>
  );
};

Loader.propTypes = {
  container: propTypes.bool,
  size: propTypes.string,
  type: propTypes.string.isRequired,
};

export { Loader };
